import { render, staticRenderFns } from "./RuleWidgetsExclude.vue?vue&type=template&id=1f40622a"
import script from "./RuleWidgetsExclude.vue?vue&type=script&lang=js"
export * from "./RuleWidgetsExclude.vue?vue&type=script&lang=js"
import style0 from "./RuleWidgetsExclude.vue?vue&type=style&index=0&id=1f40622a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports